// @mui icons
// import FacebookIcon from "@mui/icons-material/Facebook";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import GitHubIcon from "@mui/icons-material/GitHub";
// import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo-ct-dark.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Techcoo Limited",
    image: logoCT,
    route: "/",
  },
  socials: [
    // {
    //   icon: <FacebookIcon />,
    //   link: "https://www.facebook.com/CreativeTim/",
    // },
    // {
    //   icon: <TwitterIcon />,
    //   link: "https://twitter.com/creativetim",
    // },
    // {
    //   icon: <GitHubIcon />,
    //   link: "https://github.com/creativetimofficial",
    // },
    // {
    //   icon: <YouTubeIcon />,
    //   link: "https://www.youtube.com/channel/UCVyTG4sCw-rOvB9oHkzZD1w",
    // },
    {
      icon: <InstagramIcon />,
      link: "https://www.instagram.com/techcoo.co/",
    },
  ],
  menus: [
    {
      name: "Web Development",
      items: [
        { name: "Qualifly", href: "/project/qualifly" },
        { name: "Men Ying", href: "/project/menying" },
        { name: "Storage Hub", href: "/project/storagehub" },
        // { name: "freebies", href: "https://www.creative-tim.com/templates/free" },
        // { name: "premium tools", href: "https://www.creative-tim.com/templates/premium" },
        // { name: "blog", href: "https://www.creative-tim.com/blog" },
      ],
    },
    {
      name: "App Development",
      items: [
        { name: "Vivablee", href: "/project/vivablee" },
        { name: "Day Day Fit", href: "/project/daydayfit" },
        { name: "Moodfit", href: "/project/moodfit" },
        // { name: "bits & snippets", href: "https://www.creative-tim.com/bits" },
        // { name: "affiliate program", href: "https://www.creative-tim.com/affiliates/new" },
      ],
    },
    {
      name: "help & support",
      items: [
        { name: "contact us", href: "/contact" },
        // { name: "knowledge center", href: "https://www.creative-tim.com/knowledge-center" },
        // { name: "custom development", href: "https://services.creative-tim.com/" },
        // { name: "sponsorships", href: "https://www.creative-tim.com/sponsorships" },
      ],
    },
    {
      name: "Company",
      items: [
        // { name: "terms & conditions", href: "https://www.creative-tim.com/terms" },
        { name: "about us", href: "/about" },
        { name: "privacy policy", href: "/privacy-policy" },
        // { name: "licenses (EULA)", href: "https://www.creative-tim.com/license" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date + " "}
      <MKTypography
        component="a"
        href="/"
        // target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Techcoo Limited
      </MKTypography>
      .
    </MKTypography>
  ),
};
